/* eslint-disable quotes */

export const schoolList = {
  "ADMIRALTY PRIMARY SCHOOL": "1744",
  "AHMAD IBRAHIM PRIMARY SCHOOL": "1738",
  "AI TONG SCHOOL": "5625",
  "ALEXANDRA PRIMARY SCHOOL": "1266",
  "ANCHOR GREEN PRIMARY SCHOOL": "1254",
  "ANDERSON PRIMARY SCHOOL": "1766",
  "ANG MO KIO PRIMARY SCHOOL": "1150",
  "ANGLO-CHINESE SCHOOL (JUNIOR)": "5001",
  "ANGLO-CHINESE SCHOOL (PRIMARY)": "5638",
  "ANGSANA PRIMARY SCHOOL": "1268",
  "BEACON PRIMARY SCHOOL": "1249",
  "BEDOK GREEN PRIMARY SCHOOL": "1230",
  "BENDEMEER PRIMARY SCHOOL": "1129",
  "BLANGAH RISE PRIMARY SCHOOL": "1145",
  "BOON LAY GARDEN PRIMARY SCHOOL": "1640",
  "BUKIT PANJANG PRIMARY SCHOOL": "1020",
  "BUKIT TIMAH PRIMARY SCHOOL": "1247",
  "BUKIT VIEW PRIMARY SCHOOL": "1209",
  "CANBERRA PRIMARY SCHOOL": "1751",
  "CANOSSA CATHOLIC PRIMARY SCHOOL": "5029",
  "CANTONMENT PRIMARY SCHOOL": "1256",
  "CASUARINA PRIMARY SCHOOL": "1771",
  "CATHOLIC HIGH SCHOOL": "7102",
  "CEDAR PRIMARY SCHOOL": "1211",
  "CHANGKAT PRIMARY SCHOOL": "1239",
  "CHIJ (KATONG) PRIMARY": "5637",
  "CHIJ (KELLOCK)": "5005",
  "CHIJ OUR LADY OF GOOD COUNSEL": "5017",
  "CHIJ OUR LADY OF THE NATIVITY": "5007",
  "CHIJ OUR LADY QUEEN OF PEACE": "5019",
  "CHIJ PRIMARY (TOA PAYOH)": "5004",
  "CHIJ ST. NICHOLAS GIRLS' SCHOOL": "7118",
  "CHONGFU SCHOOL": "5636",
  "CHONGZHENG PRIMARY SCHOOL": "1203",
  "CHUA CHU KANG PRIMARY SCHOOL": "1244",
  "CLEMENTI PRIMARY SCHOOL": "1772",
  "COMPASSVALE PRIMARY SCHOOL": "1757",
  "CONCORD PRIMARY SCHOOL": "1760",
  "CORPORATION PRIMARY SCHOOL": "1132",
  "DAMAI PRIMARY SCHOOL": "1102",
  "DAZHONG PRIMARY SCHOOL": "1229",
  "DE LA SALLE SCHOOL": "5008",
  "EAST SPRING PRIMARY SCHOOL": "1755",
  "EDGEFIELD PRIMARY SCHOOL": "1769",
  "ELIAS PARK PRIMARY SCHOOL": "1737",
  "ENDEAVOUR PRIMARY SCHOOL": "1252",
  "EUNOS PRIMARY SCHOOL": "1119",
  "EVERGREEN PRIMARY SCHOOL": "1756",
  "FAIRFIELD METHODIST SCHOOL (PRIMARY)": "5020",
  "FARRER PARK PRIMARY SCHOOL": "1246",
  "FENGSHAN PRIMARY SCHOOL": "1657",
  "FERN GREEN PRIMARY SCHOOL": "1272",
  "FERNVALE PRIMARY SCHOOL": "1177",
  "FIRST TOA PAYOH PRIMARY SCHOOL": "1610",
  "FRONTIER PRIMARY SCHOOL": "1257",
  "FUCHUN PRIMARY SCHOOL": "1208",
  "FUHUA PRIMARY SCHOOL": "1107",
  "GAN ENG SENG PRIMARY SCHOOL": "1221",
  "GEYLANG METHODIST SCHOOL (PRIMARY)": "5022",
  "GONGSHANG PRIMARY SCHOOL": "1222",
  "GREENDALE PRIMARY SCHOOL": "1251",
  "GREENRIDGE PRIMARY SCHOOL": "1245",
  "GREENWOOD PRIMARY SCHOOL": "1765",
  "GUANGYANG PRIMARY SCHOOL": "1735",
  "HAIG GIRLS' SCHOOL": "1038",
  "HENRY PARK PRIMARY SCHOOL": "1121",
  "HOLY INNOCENTS' PRIMARY SCHOOL": "5634",
  "HONG WEN SCHOOL": "5626",
  "HORIZON PRIMARY SCHOOL": "1255",
  "HOUGANG PRIMARY SCHOOL": "1763",
  "HUAMIN PRIMARY SCHOOL": "1223",
  "INNOVA PRIMARY SCHOOL": "1250",
  "JIEMIN PRIMARY SCHOOL": "1207",
  "JING SHAN PRIMARY SCHOOL": "1166",
  "JUNYUAN PRIMARY SCHOOL": "1727",
  "JURONG PRIMARY SCHOOL": "1045",
  "JURONG WEST PRIMARY SCHOOL": "1753",
  "JUYING PRIMARY SCHOOL": "1726",
  "KEMING PRIMARY SCHOOL": "1238",
  "KHENG CHENG SCHOOL": "5608",
  "KONG HWA SCHOOL": "5168",
  "KRANJI PRIMARY SCHOOL": "1745",
  "KUO CHUAN PRESBYTERIAN PRIMARY SCHOOL": "5024",
  "LAKESIDE PRIMARY SCHOOL": "1248",
  "LIANHUA PRIMARY SCHOOL": "1232",
  "MAHA BODHI SCHOOL": "5601",
  "MARIS STELLA HIGH SCHOOL": "7111",
  "MARSILING PRIMARY SCHOOL": "1645",
  "MARYMOUNT CONVENT SCHOOL": "7301",
  "MAYFLOWER PRIMARY SCHOOL": "1151",
  "MEE TOH SCHOOL": "5183",
  "MERIDIAN PRIMARY SCHOOL": "1764",
  "METHODIST GIRLS' SCHOOL (PRIMARY)": "5027",
  "MONTFORT JUNIOR SCHOOL": "5018",
  "NAN CHIAU PRIMARY SCHOOL": "5028",
  "NAN HUA PRIMARY SCHOOL": "5622",
  "NANYANG PRIMARY SCHOOL": "5258",
  "NAVAL BASE PRIMARY SCHOOL": "1730",
  "NEW TOWN PRIMARY SCHOOL": "1621",
  "NGEE ANN PRIMARY SCHOOL": "5197",
  "NORTH SPRING PRIMARY SCHOOL": "1761",
  "NORTH VIEW PRIMARY SCHOOL": "1740",
  "NORTH VISTA PRIMARY SCHOOL": "1253",
  "NORTHLAND PRIMARY SCHOOL": "1729",
  "NORTHOAKS PRIMARY SCHOOL": "1267",
  "OASIS PRIMARY SCHOOL": "1270",
  "OPERA ESTATE PRIMARY SCHOOL": "1212",
  "PALM VIEW PRIMARY SCHOOL": "1263",
  "PARK VIEW PRIMARY SCHOOL": "1743",
  "PASIR RIS PRIMARY SCHOOL": "1243",
  "PAYA LEBAR METHODIST GIRLS' SCHOOL (PRIMARY)": "5635",
  "PEI CHUN PUBLIC SCHOOL": "5602",
  "PEI HWA PRESBYTERIAN PRIMARY SCHOOL": "5623",
  "PEI TONG PRIMARY SCHOOL": "1650",
  "PEIYING PRIMARY SCHOOL": "1236",
  "PIONEER PRIMARY SCHOOL": "1741",
  "POI CHING SCHOOL": "5603",
  "PRINCESS ELIZABETH PRIMARY SCHOOL": "1228",
  "PUNGGOL COVE PRIMARY SCHOOL": "1269",
  "PUNGGOL GREEN PRIMARY SCHOOL": "1259",
  "PUNGGOL PRIMARY SCHOOL": "1742",
  "PUNGGOL VIEW PRIMARY SCHOOL": "1260",
  "QIFA PRIMARY SCHOOL": "1197",
  "QIHUA PRIMARY SCHOOL": "1734",
  "QUEENSTOWN PRIMARY SCHOOL": "1071",
  "RADIN MAS PRIMARY SCHOOL": "1072",
  "RAFFLES GIRLS' PRIMARY SCHOOL": "1073",
  "RED SWASTIKA SCHOOL": "5214",
  "RIVER VALLEY PRIMARY SCHOOL": "1217",
  "RIVERSIDE PRIMARY SCHOOL": "1264",
  "RIVERVALE PRIMARY SCHOOL": "1752",
  "ROSYTH SCHOOL": "1077",
  "RULANG PRIMARY SCHOOL": "1195",
  "SEMBAWANG PRIMARY SCHOOL": "1759",
  "SENG KANG PRIMARY SCHOOL": "1746",
  "SENGKANG GREEN PRIMARY SCHOOL": "1261",
  "SHUQUN PRIMARY SCHOOL": "1220",
  "SI LING PRIMARY SCHOOL": "1161",
  "SINGAPORE CHINESE GIRLS' PRIMARY SCHOOL": "5026",
  "SOUTH VIEW PRIMARY SCHOOL": "1241",
  "SPRINGDALE PRIMARY SCHOOL": "1262",
  "ST. ANDREW'S JUNIOR SCHOOL": "5009",
  "ST. ANTHONY'S CANOSSIAN PRIMARY SCHOOL": "5011",
  "ST. ANTHONY'S PRIMARY SCHOOL": "5259",
  "ST. GABRIEL'S PRIMARY SCHOOL": "5012",
  "ST. HILDA'S PRIMARY SCHOOL": "5025",
  "ST. JOSEPH'S INSTITUTION JUNIOR": "5014",
  "ST. MARGARET'S PRIMARY SCHOOL": "5013",
  "ST. STEPHEN'S SCHOOL": "5015",
  "STAMFORD PRIMARY SCHOOL": "1174",
  "TAMPINES NORTH PRIMARY SCHOOL": "1736",
  "TAMPINES PRIMARY SCHOOL": "1201",
  "TANJONG KATONG PRIMARY SCHOOL": "1773",
  "TAO NAN SCHOOL": "5240",
  "TECK GHEE PRIMARY SCHOOL": "1158",
  "TECK WHYE PRIMARY SCHOOL": "1043",
  "TELOK KURAU PRIMARY SCHOOL": "1218",
  "TEMASEK PRIMARY SCHOOL": "1160",
  "TOWNSVILLE PRIMARY SCHOOL": "1189",
  "UNITY PRIMARY SCHOOL": "1750",
  "VALOUR PRIMARY SCHOOL": "1273",
  "WATERWAY PRIMARY SCHOOL": "1271",
  "WELLINGTON PRIMARY SCHOOL": "1767",
  "WEST GROVE PRIMARY SCHOOL": "1770",
  "WEST SPRING PRIMARY SCHOOL": "1265",
  "WEST VIEW PRIMARY SCHOOL": "1748",
  "WESTWOOD PRIMARY SCHOOL": "1258",
  "WHITE SANDS PRIMARY SCHOOL": "1749",
  "WOODGROVE PRIMARY SCHOOL": "1758",
  "WOODLANDS PRIMARY SCHOOL": "1114",
  "WOODLANDS RING PRIMARY SCHOOL": "1747",
  "XINGHUA PRIMARY SCHOOL": "1205",
  "XINGNAN PRIMARY SCHOOL": "1731",
  "XINMIN PRIMARY SCHOOL": "1724",
  "XISHAN PRIMARY SCHOOL": "1227",
  "YANGZHENG PRIMARY SCHOOL": "1725",
  "YEW TEE PRIMARY SCHOOL": "1762",
  "YIO CHU KANG PRIMARY SCHOOL": "1143",
  "YISHUN PRIMARY SCHOOL": "1172",
  "YU NENG PRIMARY SCHOOL": "1658",
  "YUHUA PRIMARY SCHOOL": "1656",
  "YUMIN PRIMARY SCHOOL": "1219",
  "ZHANGDE PRIMARY SCHOOL": "1199",
  "ZHENGHUA PRIMARY SCHOOL": "1240",
  "ZHONGHUA PRIMARY SCHOOL": "1235"
}

export const phaseList = ['1', '2A', '2B', '2C']
